import React from "react";
import { Alert, Container } from "react-bootstrap";

const Message = ({ variant, children }) => {
  return (
    <Container className="w-50 d-flex align-items-center">
      <Alert variant={variant}>{children}</Alert>
    </Container>
  );
};

export { Message };
